<template>
  <div class="foot-container">
    <div class="foot-content">
      <div class="foot-slogan">
        <h1>让世界更安静，让工业更智能!</h1>
        <p class="slogan-sub">伟思特团队与您共创声学新纪元！</p>
      </div>
      <div class="contact-list">
        <div class="contact-item">
          <el-icon name="phone" class="contact-icon"></el-icon>
          <span class="contact-text">电话：{{ form.phone1 }}({{ form.phonePrincipals }})<template
              v-if="form.phone2">&emsp;{{ form.phone2 }}({{ form.phonePrincipals1 }})</template></span>
        </div>
        <div class="contact-item">
          <el-icon name="message" class="contact-icon"></el-icon>
          <span class="contact-text">邮箱：{{ form.email1 }}({{ form.emailPrincipals }})<template
              v-if="form.email2">&emsp;{{ form.email2 }}({{ form.emailPrincipals1 }})</template></span>
        </div>
        <div class="contact-item">
          <el-icon name="location" class="contact-icon"></el-icon>
          <span class="contact-text">地址：{{ form.address }}</span>
        </div>
      </div>
    </div>
    <hr class="foot-divider">
    <div class="author">
      <span>版权所有 © 2025 西安伟思特声学科技有限公司</span>
      <a href="https://beian.miit.gov.cn/" target="_blank">陕ICP备2025072211号</a>
      <span class="beian-group">
        <img src="@/assets/img/head-logo.png" width="16"/>
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=61019002003357" rel="noreferrer" target="_blank">陕公网安备61019002003357号</a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Foot",
  data() {
    return {
      form: {
        emailPrincipals: '杨经理',
        emailPrincipals1: '',
        email1: 'owen.yang@weste-group.com',
        email2: '',
        phonePrincipals: '杨经理',
        phonePrincipals1: '',
        phone1: '13929462171',
        phone2: '',
        address: '陕西省西安市高新区郭杜西街38号熙峰广场601A',
      },
    }
  },
  created() {
    this.getForm();
  },
  methods: {
    getForm() {
      const item = sessionStorage.getItem("appInfo");
      if (item) {
        this.form = JSON.parse(item);
        return;
      }
      this.$api.getAppInfo().then(res => {
        if (res.code !== 200) {
          this.$message.error(res.message);
          return;
        }
        this.form = res.data;
        sessionStorage.setItem("appInfo", JSON.stringify(res.data));
      })
    }
  }
}
</script>

<style scoped>
.foot-container {
  width: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 20px;
  box-sizing: border-box;
  background-color: #000028;
}

.foot-content {
  color: white;
  text-align: center;
}

.foot-slogan h1 {
  margin: 0 0 10px;
  font-size: 28px;
}

.slogan-sub {
  margin: 0 0 20px;
  font-size: 16px;
}

.contact-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  margin-top: 20px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  text-align: left;
}

.contact-icon {
  font-size: 24px;
  color: white;
  margin-right: 10px;
  flex-shrink: 0;
  margin-top: 2px;
}

.contact-text {
  font-size: 16px;
  line-height: 1.6;
  word-break: break-all;
}

.foot-divider {
  border: none;
  border-top: 1px solid white;
  width: 100%;
  margin: 20px 0;
}

.author {
  color: #999999;
  font-size: 14px;
  text-align: center;
  line-height: 1.8;
}

.author a {
  color: inherit;
  text-decoration: none;
  margin: 0 8px;
}

.author a:hover {
  text-decoration: underline;
}

.beian-group {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.beian-group img {
  vertical-align: middle;
}

@media screen and (max-width: 768px) {
  .foot-container {
    min-height: auto;
    padding: 24px 16px;
  }

  .foot-slogan h1 {
    font-size: 22px;
  }

  .slogan-sub {
    font-size: 14px;
  }

  .contact-list {
    align-items: stretch;
    width: 100%;
  }

  .contact-item {
    align-items: flex-start;
  }

  .contact-icon {
    font-size: 20px;
    margin-top: 2px;
  }

  .contact-text {
    font-size: 14px;
  }

  .author {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .author a {
    margin: 0;
  }

  .beian-group {
    display: inline-flex;
    align-items: center;
  }
}
</style>
